import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.5852 14.4677C15.4581 14.4677 16.1665 13.7616 16.1692 12.8887V12.8887V12.8887C16.1687 12.4446 15.9914 12.0189 15.6765 11.7057L14.6269 10.6553V7.53479C14.6267 6.30826 14.1389 5.13211 13.2711 4.26537C12.4033 3.39863 11.2265 2.91237 9.99997 2.9137V2.9137C7.44865 2.91508 5.38101 4.98348 5.38055 7.53479V10.6528L4.33094 11.7032C4.01584 12.0163 3.83827 12.442 3.8374 12.8862V12.8862V12.8862C3.84016 13.7591 4.54853 14.4652 5.4214 14.4652L14.5852 14.4677Z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.76709 17.0863H11.2323",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgBell;
